import React from 'react';
import cx from 'classnames';
import Image from 'next/image';
import PropTypes from 'prop-types';
import SignUpButton from '@/components/premium/SignUpButton';
import { useTranslation } from '@separate/hooks/translation';
import useCurrentWidth from '@separate/hooks/useCurrentWidth';
import { csLoader } from '@separate/utilities/image';
import styles from './benefitsCarousel.module.scss';

const BenefitsCard = ({
  loading,
  isLoggedIn,
  isPremiumMember,
  couponText,
  offset,
  active
}) => {
  const { t } = useTranslation();
  const width = useCurrentWidth();

  const benefits = [
    {
      id: 1,
      image: 'https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/blt3a3d158ca876a282/641f522ff7f13d3cb7089ab9/DentalDiscounts.png',
      title: t('benefits.podersalud.dental.title'),
      description: t('benefits.podersalud.dental.description'),
      items: [...t('benefits.podersalud.dental.items', { returnObjects: true })]
    },
    {
      id: 2,
      image: 'https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/bltdd2bb6488daef293/641bcb0c9d04a8544bd871fb/OnDemandTelehealth.png',
      title: t('benefits.podersalud.telehealth.title'),
      description: t('benefits.podersalud.telehealth.description'),
      items: [...t('benefits.podersalud.telehealth.items', { returnObjects: true })]
    },
    {
      id: 3,
      image: 'https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/blt02f58fb28942bcfc/641bda082f651e4e5d0f8fac/PrescriptionDiscounts.png',
      title: t('benefits.podersalud.prescription.title'),
      description: t('benefits.podersalud.prescription.description'),
      items: [...t('benefits.podersalud.prescription.items', { returnObjects: true })],
    },
    {
      id: 4,
      image:
        'https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/bltb6ac13098aa13340/641f532ff2a10e3b5426cf45/VisionDiscounts.png',
      title: t('benefits.podersalud.vision.title'),
      description: t('benefits.podersalud.vision.description'),
      items: [...t('benefits.podersalud.vision.items', { returnObjects: true })],
    },
    {
      id: 5,
      image: 'https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/blt4077f171df7d722c/641f53caf25d79224156a24d/ExclusiveEarnings.png',
      title: t('benefits.podersalud.earnings.title'),
      description: t('benefits.podersalud.earnings.description'),
      items: [...t('benefits.podersalud.earnings.items', { returnObjects: true })]
    }
  ];

  return (
    <>
      {benefits.map((benefit) => (
        <div
          key={benefit.id}
          className='p-2 mx-2'
          style={{ width: `${offset}px` }}
        >
          <div className={cx(styles.benefitsCard, width < 768 ? { [styles.active]: benefit.id === active } : styles.active)}>
            <Image
              src={benefit.image}
              alt='benefit image'
              loader={csLoader}
              height='153'
              width={offset}
            />

            <div className={styles.content}>
              <div>
                <p className={styles.title}>{benefit.title}</p>
                <p className={styles.description}>{benefit.description}</p>
                <ul>
                  {benefit.items.map((item) => (
                    <li key={item.text}>{item.text}</li>
                  ))}
                </ul>
              </div>
              <div>
                <SignUpButton
                  loading={loading}
                  isLoggedIn={isLoggedIn}
                  isPremiumMember={isPremiumMember}
                  couponText={couponText}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

BenefitsCard.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.array,
  className: PropTypes.string,
  stores: PropTypes.string,
  loading: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isPremiumMember: PropTypes.bool,
  couponText: PropTypes.any,
  offset: PropTypes.number,
  active: PropTypes.number
};

export default BenefitsCard;
